<template>
  <div>
    <v-stepper v-model="step" tile>
      <v-stepper-header>
        <v-stepper-step editable :step="1">
          Flexible Options
        </v-stepper-step>
        <v-divider />
        <v-stepper-step editable :step="2">
          Build your own Reverse Mortgage
        </v-stepper-step>
        <v-divider />
        <v-stepper-step editable :step="3">
          Summary
        </v-stepper-step>
        <v-divider />
        <v-stepper-step editable :step="4">
          Next Steps
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content :step="1">
          <div class="d-flex justify-space-between mb-8">
            <div></div>
            <v-btn color="primary" @click="nextStep()"> Next </v-btn>
          </div>

          <div class="ma-2 flex1 mx-auto" style="max-width: 1100px;">

            <div class="medium-small-text-font mb-2 text-center">Growth in benefits
            </div>
            <IncreaseFunds />
            <div class="medium-small-text-font mb-2 mt-8 text-center">Static example</div>
            <StaticExample />
          </div>
        </v-stepper-content>

        <v-stepper-content :step="2">
          <div class="d-flex justify-space-between mb-8">
            <v-btn @click="backStep()"> Back </v-btn>
            <v-btn color="primary" @click="nextStep()"> Next </v-btn>
          </div>
          <div class="ma-2 flex1 mx-auto" style="max-width: 1100px;">
            <BuildYourOwnRM />
          </div>
        </v-stepper-content>

        <v-stepper-content :step="3">
          <div class="d-flex justify-space-between mb-8">
            <v-btn @click="backStep()"> Back </v-btn>
            <v-btn color="primary" @click="nextStep()"> Next </v-btn>
          </div>
          <Summary />
        </v-stepper-content>

        <v-stepper-content :step="4">
          <div class="d-flex justify-space-between mb-8">
            <v-btn @click="backStep()"> Back </v-btn>
            <div></div>
          </div>
          <LeadCapture />
        </v-stepper-content>

      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import IncreaseFunds from './IncreaseFunds.vue';
import StaticExample from './StaticExample.vue';
import BuildYourOwnRM from './BuildYourOwnRM/index.vue';
import Summary from '../Summary/index.vue';
import LeadCapture from '../../views/LeadCapture/index.vue';

export default {
  data: () => ({
    step: 1,
    maxStep: 4,
  }),
  components: { IncreaseFunds, StaticExample, BuildYourOwnRM, Summary, LeadCapture },
  methods: {
    nextStep() {
      if (this.step < this.maxStep) this.step++;
    },
    backStep() {
      if (this.step > 1) this.step--;
    },
  }
}

</script>

<style></style>
